<!------------------------------------->
<!-- List tab detail layout.
 * File Name ..: requests.component.html
 * Generated by: ianday
 * Date .......: 10/13/23
--------------------------------------->
<div class="requests-form-container">
    <div class="query-strip-container mat-elevation-z2">
        <table height="100%" style="font-size: 9pt">
            <TR>

                <TD style="width: 25%; text-align: left; padding-left: 10px;">
                    Show: &nbsp;&nbsp;
                    <dw-dropdown [disabled]="busyCursor"
                            [selectedItem]="selectedViewFilter"
                            (itemSelected)="selectedViewFilter = $event; onChangeViewFilterValue()"
                            [dataSource]="showList"
                            [controlWidth]="'180px'"
                            matTooltip="Choose from pre-selected lists">
                    </dw-dropdown>

                </TD>
                <TD align="left" style="min-width: 300px; width: 35%;text-align: center; ">
                    <input text id="txtFilter" #txtFilter
                           class="qs_filter-field" [disabled]="busyCursor" [(ngModel)]="strFilterText"
                           matTooltip = "Type to match data in all columns except date fields"
                           (keyup)="applyFilter($event.target.value)" placeholder="<Filter>">
                    <button mat-button matSuffix mat-icon-button [disabled]="busyCursor"
                            matTooltip="Clear the filter" aria-label="Clear"
                            (click)="txtFilter.value=''; clearFilter();">
                        <mat-icon style="scale: 80%;">close</mat-icon>
                    </button>
                    <button mat-button matSuffix mat-icon-button
                            matTooltip="Refresh the grid" aria-label="Refresh"
                            (click)="txtFilter.value=''; refreshButtonClickHandler();">
                        <mat-icon style="scale: 80%;">refresh</mat-icon>
                    </button>

                    <button mat-button class="command-button" [disabled]="busyCursor" *ngIf="visibleGlobalSearch"
                            matTooltipPosition="below"
                            style="margin-top: 5px; width:100px;"
                            matTooltip="Query the system for service request records" (click)="doGlobalSearch()"
                            mat-button>
                        <mat-icon>search</mat-icon>
                        Search
                    </button>

                </TD>
                <TD class="qs-label-cell" *ngIf="(showUnLimitedStatusFilter || showRestrictedStatusFilter)"
                    style="width: 25%; min-width: 300px;text-align: right">Request
                    Status:&nbsp;&nbsp;
                    <dw-dropdown [disabled]="busyCursor" 
                            [selectedItem]="selectedStatusFilter?.id"
                            (itemSelected)="selectedStatusFilter.id = atoi($event); onChangeStatusFilterValue()"
                            [dataSource]="showStatusList"
                            [controlWidth]="'100px'"
                    matTooltip="Filter the list by a status">
                    </dw-dropdown>

                  <TD class="table-pagination-cell" align="right" style="font-size:10pt;" >{{pagination}} Record(s) ...</TD>
            </TR>
        </table>
    </div>

        <div class="main-client-area">
            <!--------------------------->
            <!-- RECORDS TABLE         -->
            <!--------------------------->
            <div #tb1 [ngClass]="contentClassName" class="mat-elevation-z1"
                 (keydown)="tableKeyDown($event)" tabindex="-1" id="requestTableId">
                <table mat-table [dataSource]="dataSource" matSort
                       (matSortChange)="onSortChange($event)">

                  <ng-container matColumnDef="id" style="width: 40px;">
                      <th mat-header-cell *matHeaderCellDef class="mat-table-header-style table-header-class"
                          [hidden]="false" mat-sort-header>Id</th>
                      <td mat-cell *matCellDef="let element" class="table-row-class" style="padding-right: 5px;;">
                      {{element.id}} </td>
                  </ng-container>

                  <ng-container matColumnDef="collaborationRequest" style="width: 6px;">
				    <th mat-header-cell *matHeaderCellDef class="mat-table-header-style table-header-class">
                        <mat-icon style="scale: 80%">share</mat-icon></th>
				    <td mat-cell *matCellDef="let element" class="table-row-class" class="width: 10px">
                        <div *ngIf="element.plannedCommitted.length > 0">
                           <mat-icon tabindex="0"
							          style="scale: 70%;"
							          (mouseover)="handleCollabFocus(element)"
							          [matTooltip]="'Collaboration Status: ' + element.plannedCommitted + '\n' + element.collabList"
							          matTooltipPosition="right"
							          [ngStyle]="{'color': getCollaborationIconColor(element.plannedCommitted) }">
							  share
							</mat-icon>
						</div>
                    </td>
				  </ng-container>
				
				  <!-- Case Number Column -->
				  <ng-container matColumnDef="caseNumber">
				    <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-table-header-style table-header-class"> Case
                        Number </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class"> {{element.caseNumber}} </td>
				  </ng-container>
				  
				  <!-- Case Name Column -->
				  <ng-container matColumnDef="caseName">
				    <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-table-header-style table-header-class"> Case
                        Name </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class"> {{element.caseName}} </td>
				  </ng-container>
				  
				   <!-- Agency Name Column -->
				  <ng-container matColumnDef="agencyName">
				    <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-table-header-style table-header-class">
                        Agency</th>
				    <td mat-cell *matCellDef="let element" class="table-row-class"> {{element.agencyName}} </td>
				  </ng-container>
				
				  <!-- Request Type Column -->
				  <ng-container matColumnDef="serviceRequestDesc">
				    <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-table-header-style table-header-class"> Request
                        Type </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class"> {{element.serviceRequestDesc}} </td>
				  </ng-container>
				
				  <!-- Date Created Column -->
				  <ng-container matColumnDef="dateCreated">
				    <th mat-header-cell *matHeaderCellDef  mat-sort-header class="mat-table-header-style table-header-class"> Date
                        Created </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class"> {{element.dateCreated | date:'mediumDate':'EST'}} </td>
				  </ng-container>
				
				  <!-- Due Date Column -->
				  <ng-container matColumnDef="dueDate">
				    <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-table-header-style table-header-class"> Due Date
                    </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class"> {{element.dueDate | date:'mediumDate':'EST'}} </td>
				  </ng-container>
				
				  <!-- Days Lapsed Column -->
				  <ng-container matColumnDef="daysLapsed" >
				    <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-table-header-style table-header-class"> Days
                        Lapsed </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class" style="text-align: center;width: 60px;max-width: 70px"> {{element.daysLapsed}} </td>
				  </ng-container>
				
				  <!-- Days Left Column -->
				  <ng-container matColumnDef="daysLeft">
				    <th mat-header-cell *matHeaderCellDef  mat-sort-header class="mat-table-header-style table-header-class"> Days
                        Left </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class" style="text-align: center;width: 60px;max-width: 70px"
                        [ngStyle]="{'border': '1.5px solid white', 'background-color': getBackgroundColor(element) }">
                        {{element.daysLeft}} </td>
				  </ng-container>
				
				  <!-- Requested Column -->
				  <ng-container matColumnDef="amountRequested">
				    <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-table-header-style table-header-class"
                        style="padding-left: 8px;">
                        Requested </th>
				    <td mat-cell *matCellDef="let element" style="padding-left: 8px;" class="table-row-class">
                        {{amountLabel(element.id, true)}} </td>
				  </ng-container>
				
				  <!-- Provided Column -->
				  <ng-container matColumnDef="totalAmountProvided">
				    <th mat-header-cell *matHeaderCellDef mat-sort-header class="mat-table-header-style table-header-class"> Provided
                    </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class">
                        {{amountLabel(element.id, false)}}</td>
				  </ng-container>
				
				  <!-- Status Column -->
				  <ng-container matColumnDef="requestStatusDesc" >
				    <th mat-header-cell *matHeaderCellDef mat-sort-header  class="mat-table-header-style table-header-class"> Status
                    </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class"> {{element.requestStatusDesc}} </td>
				  </ng-container>
				  
				  <!-- WIP Column -->
				  
				    <ng-container matColumnDef="keepOpen" >
				    <th mat-header-cell *matHeaderCellDef mat-sort-header
                        class="mat-table-header-style table-header-class" style="width:80px;"
                        matTooltip="Prevent auto-close">Prevent Auto-close</th>
            <td mat-cell *matCellDef="let element" class="table-row-class" style="text-align:center;">
                            <mat-icon *ngIf="element.keepOpen" aria-hidden="true">check</mat-icon>
                        </td>
				  </ng-container>
				  
				   
				  <ng-container matColumnDef="btnDetails" >
				    <th mat-header-cell *matHeaderCellDef mat-sort-header  class="mat-table-header-style table-header-class">
                    </th>
				    <td mat-cell *matCellDef="let element" class="table-row-class"> 
				    	<mat-icon  *ngIf="showRequestDetailsdialog" aria-hidden="false" class="command-icon-style" (click)="onClipboardClicked(element)"
                                  style="cursor:
				    	pointer;"
                                  [matTooltip]="'Click to view details'">assignment
				    	</mat-icon> 
				    </td>
				  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                  <tr mat-row
                      *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                      [ngClass]="{'row-selected': tableRowIdx == Idx}"
                      (click)="onRowClicked(row)"  (dblclick)="onRowDoubleClicked(row)">
                  </tr>
                </table>
                <app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
            </div>
        </div>
</div>

<p-dialog header="Global Search" [focusOnShow]="false"
          [(visible)]="displaySearchDlg" [modal]="true"
          [style]="{width: '1130px', height: '735px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-globalsearch #globalSearch
                      (submitClicked)="globalSearchSelect($event)"
                      (cancelClicked)="displaySearchDlg=false">
    </app-globalsearch>
</p-dialog>

<p-dialog *ngIf="displayRequestDetailsDlg" header="Request Details" [focusOnShow]="true"
         [(visible)]="displayRequestDetailsDlg" [modal]="true"
         [style]="{ 'width': '1300px', 'height': '780px', 'min-width': '1300px', 'min-height': '780px',
         'overflow':'auto' }"
         appendTo="body"
         [minY]="45" [resizable]="false" [closable]="false">

    <app-requestdetails [(selectedServiceRequest)]="selectedRecord"
        (cancelClicked)="displayRequestDetailsDlg=false" (editEvent)="isRequestDetailsEditing=$event">
    </app-requestdetails>

     <ng-template pTemplate="footer" style="position: absolute; bottom: 5px; ">
              <div style="text-align: center;">
			<button mat-button class="command-button" [disabled]="isRequestDetailsEditing"
			                           (click)="doClose()" matTooltip="Close window"
					  mat-button>
				  <mat-icon>cancel</mat-icon>
				  Close
			  </button>
		</div>
        </ng-template>
</p-dialog>

<p-dialog *ngIf="displayCaseDetailsDlg" header="Case Details" [focusOnShow]="true"
          [(visible)]="displayCaseDetailsDlg" [modal]="true"
          [style]="{ 'width': '1300px', 'height': '780px', 'min-width': '1300px',
          'min-height': '780px','overflow':'auto'  }"
          appendTo="body"
          [minY]="45" [resizable]="false" [closable]="false">
    <app-case-details-dialog
            [selectedId]="selectedRecord?.caseId">
    </app-case-details-dialog>
    <ng-template pTemplate="footer">
        <div style="text-align: center;">
            <button mat-button class="command-button" [disabled]="isRequestDetailsEditing"
                    (click)="doCaseDlgClose()" matTooltip="Close window"
                    mat-button>
                <mat-icon>cancel</mat-icon>
                Close
            </button>
        </div>
    </ng-template>
</p-dialog>
